import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ nr, overline, title, className = "" }) => (
  <Reveal className={`max-w-3xl ${className}`}>
    <div className="mb-5 flex items-center gap-4">
      <span className="font-heading text-xs font-semibold tracking-[0.3em] text-[#FF8A00]">{nr}</span>
      <span className="h-px w-10 bg-[#FF8A00]/50" aria-hidden="true" />
      <span className="font-heading text-xs font-semibold uppercase tracking-[0.25em] text-[#62C3F0]">
        {overline}
      </span>
    </div>
    <h2 className="font-heading text-base font-bold tracking-tight text-[#F5F7F9] sm:text-3xl md:text-4xl md:leading-tight">
      {title}
    </h2>
  </Reveal>
);
